import type { PublicRouteClassifierContribution } from '#kernel/public-site/public-route-classifier-types.ts';

export const PRIVATE_TIMELINE_BUILDER_PUBLIC_PATH = '/private-timeline-builder';

export default {
  id: 'private-timeline-builder',
  paths: [PRIVATE_TIMELINE_BUILDER_PUBLIC_PATH],
} as const satisfies PublicRouteClassifierContribution;
